// 评论野蛮
export default {
  className: 'evalute',
  defaultOrder: '-updatedAt',
  fields: [
    {
      name: 'proTitle',
      note: '评论标题/日记内容',
      width: 400,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'evaContent',
      width: 400,
      validators: [
        (value) => value ? null : '不可为空'
      ]
    },
    {
      name: 'user',
      note: '评论者'
    },
    {
      'name': 'replyList',
      'note': '回复列表',
      'type': 'Array',
      'items': {
        'type': 'Object',
        'items': [
          {
            'name': 'replyUser',
            'note': '回复的用户',
            'type': 'Object',
            'items': [
              { 'name': 'wechatName', 'note': '昵称', 'type': 'String', disabled: true },
              { 'name': 'avatar', 'note': '头像', 'type': 'Image', disabled: true },
              { 'name': 'phone', 'note': '电话', 'type': 'String', disabled: true }
            ]
          },
          { 'name': 'content', 'note': '回复内容', 'type': 'String' },
          { 'name': 'date', 'note': '回复时间', 'type': 'Date', disabled: true }
        ]
      }
    },
    {
      name: 'contentType',
      width: 150
    }
  ],
  search: [
    'proTitle',
    'contentType'
  ],
  action: {
    export: false,
    create: false,
    edit: {
      fieldsPlus: {
        wechatName: {
          disabled: true
        },
        contentType: {
          disabled: true
        }
      }
    },
    delete: false,
    view1: {
      type: 'row',
      text: '删除',
      callback: async ({ record, vm, modelName }) => {
        await vm.confirm('警告', '你确定要删除这条记录吗?')
        let rs = await vm.$modelAjax.delete(modelName, record.objectId).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '删除数据失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '记录已被删除'
          })
          vm.refresh()
        }
      }
    }
  }
}
